import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actions, ApplicationStore } from "src/store";
import AccessGarage from "./state";

function mapStateToProps({ account }: ApplicationStore) {
    return {
        accountSlug: (account && account.slug) || "",
    };
}

const updateAccessRequest = actions.deal.updateAccessRequest;

const mapDispatchToProps = (dispatch: any) =>
    bindActionCreators(
        {
            updateAccessRequest,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AccessGarage);
